<template lang="pug" src="./clientRefillHistory.pug"></template>
<style lang="scss" src="./clientRefillHistory.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex'
import validationMixin from '@/mixins/validate'
import scroll from '@/utils/scroll'
import copyToClipboard from '../../utils/copy'

export default {
    mixins: [validationMixin],
    data: () => ({
        filters: {
            phoneNumber: null,
            email: null,
            fromDate: null,
            toDate: null
        },
        sorting: {}
    }),
    computed: {
        ...mapGetters['type'],
        ...mapState({
            clientRefillHistory: state => state.clientRefillHistory.clientRefillHistory,
            pagination: state => state.clientRefillHistory.pagination,
            appliedFilters: state => state.clientRefillHistory.filters,
            isTableLoad: state => state.clientRefillHistory.isLoaded
        }),
        headers() {
            return [
                { text: 'date', value: '"createdAt"' },
                { text: 'phoneNumber', sortable: false },
                { text: 'change', value: '"change"' },
                { text: 'balance', value: '"balance"' },
                { text: 'refilledBy', value: '"account"."email"' },
                { text: 'comment', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`$vuetify.pages.clientRefillHistory.table.${it.text}`)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getClientRefillHistoryByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getClientRefillHistoryByPage(this.pagination.page)
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('clientRefillHistory/SET_PAGINATION', { page: 1, length: null })
        this.$store.commit('clientRefillHistory/RESET_CLIENT_REFILL_HISTORY')
        next()
    },
    methods: {
        reset() {
            this.filters = Object.assign({}, {
                clientPhoneNumber: null,
                email: null,
                fromDate: null,
                toDate: null
            })
            this.$store.commit('clientRefillHistory/RESET_CLIENT_REFILL_HISTORY')
            this.getClientRefillHistoryByPage()
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getClientRefillHistoryByPage(page, true)
            }
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        submit() {
            this.$store.commit('clientRefillHistory/SET_FILTERS', Object.assign({}, this.filters))
            this.getClientRefillHistoryByPage()
        },
        getClientRefillHistoryByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('clientRefillHistory/getClientRefillHistory', {
                page,
                excel,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        copy(text) {
            if (text) {
                copyToClipboard(text)
            }
        },
        exportToExcel() {
            this.getClientRefillHistoryByPage(1, false, true)
        }
    }
}
</script>
